import { applySeo } from "@/lib/seo-head";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import justice from "@/assets/charlene-building.webp";
import { useT, useMedia } from "@/lib/i18n";

export const Route = createFileRoute("/about/mision")({
  component: Mision,
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => ({
    meta: [
      { title: "Misión y valores — RR Lex Juristas" },
      { name: "description", content: "Nuestra misión: proteger tus derechos con cercanía, transparencia y compromiso con la justicia social." },
      { property: "og:title", content: "Misión y valores — RR Lex Juristas" },
      { property: "og:description", content: "Cómo entendemos la abogacía: con vocación, transparencia y soluciones eficaces." },
      { property: "og:url", content: "https://rrlexjuristas.com/about/mision" },
      { property: "og:image", content: justice },
    ],
    links: [{ rel: "canonical", href: "https://rrlexjuristas.com/about/mision" }],
  }))(ctx)),
});

function Mision() {
  const { tk } = useT();
  const building = useMedia("sobre.building", justice, "Edificio del despacho");

  return (
    <Layout>
      <section className="border-y border-gold/15 bg-card/40">
        <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-gold">{tk("sobre.1a1c47", "Nuestra Misión")}</span>
            <h1 className="font-serif text-4xl md:text-5xl mt-4">
              {tk("sobre.24fb1d", "Proteger sus derechos con cercanía y firmeza.")}
            </h1>
            <div className="gold-divider my-6 max-w-[100px]" />
            <p className="text-muted-foreground leading-relaxed">
              {tk("sobre.43f73d", "Creamos relaciones de confianza duraderas con nuestros clientes, basadas en la transparencia, el respeto y la búsqueda de soluciones eficaces.")}
            </p>
            <ul className="mt-8 space-y-4">
              {[
                tk("sobre.41d131", "Compromiso con las personas, no con los conflictos."),
                tk("sobre.0d7b2f", "Transparencia: honorarios claros y trato honesto."),
                tk("sobre.91af3a", "Igualdad y justicia social como base de nuestra práctica."),
                tk("sobre.dd9aac", "Innovación jurídica: aplicamos métodos alternativos como la mediación."),
              ].map((v) => (
                <li key={v} className="flex gap-4">
                  <span className="text-gold font-serif text-xl leading-none">✦</span>
                  <span className="text-foreground/80">{v}</span>
                </li>
              ))}
            </ul>
            <Link to="/contact" className="mt-10 inline-flex items-center gap-3 rounded-full bg-gold text-primary-foreground px-7 py-3.5 text-xs tracking-[0.3em] uppercase hover:bg-[oklch(0.88_0.08_85)] transition-colors">
              {tk("sobre.0d77c3", "Contacta con nosotras")}
            </Link>
          </div>
          <div className="relative">
            <img src={building.url} alt={building.alt} width={1200} height={1400} loading="lazy" className="w-full h-[560px] object-cover rounded-xl" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
